import reduxStore from 'redux/store'
import {clearResource, setResource} from 'redux/actions'
import Endpoints from 'constants/Endpoints';
import {RestRequestGET} from 'libs/RestRequest';
import applySearchParams from "../libs/applySearchParams";


const get = async (page = 1, pageSize = 10, filters = {}, sort = {}) => {

    const {
        column,
        direction
    } = sort

    let params = {
        'page': page,
        'pageSize': pageSize
    }
    params = applySearchParams(filters, params);

    if (column) {
        params['sort[0].column'] = column
        params['sort[0].direction'] = direction.toUpperCase()
    }

    try {
        const res = await RestRequestGET(Endpoints.DEMANDS, {
            params
        });
        reduxStore.dispatch(
            setResource('demands', res)
        )
    } catch (error) {
    }
}

const clear = () => {
    reduxStore.dispatch(
        clearResource('demands')
    )
}

export default {
    get,
    clear,
}

